import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { publishMetric } from '@cp/utils/ameyoDiagnostics';
import { Roles, WA_PLUGIN_VERSION } from '@cp/pages/auth/constants/AuthConstants';
import { IAmeyoDiagnosticPayload } from '@cp/constants/ameyoConstants';
import { LocalStorage } from '@cp/utils/StorageUtils';

const useAmeyoDiagnostics = () => {
  const referenceId = useSelector((state: RootState) => state.common.userData.referenceId);
  const roles = useSelector((state: RootState) => state.common.userData.roles);
  const teleAmeyoCampaignId = useSelector(
    (store: RootState) => store?.common?.userData?.campaignId
  );
  const hrcAmeyoCampaignId = useSelector((store: RootState) => store?.humanReminder?.campaignId);
  const isHRCAgent = useMemo(() => roles?.includes(Roles.ROLE_HUMAN_REMINDER_AGENT), [roles]);
  const latestExtensionVersion = useSelector((state: RootState) => state?.common?.extensionVersion);
  const isImpersonation = useSelector(
    (state: RootState) => state?.common?.userData?.userImpersonated
  );

  const sendAmeyoDiagnostics = (diagnostics: IAmeyoDiagnosticPayload) => {
    if (!isImpersonation) {
      publishMetric({
        agentReferenceId: referenceId,
        agentExtensionVersion: LocalStorage.getItem(WA_PLUGIN_VERSION),
        latestExtensionVersion: latestExtensionVersion,
        campaignId: `${isHRCAgent ? hrcAmeyoCampaignId : teleAmeyoCampaignId}`,
        flow: diagnostics?.metricName,
        metricType: diagnostics?.metricType,
        value: diagnostics?.value,
        roles: roles as Roles[],
        group: diagnostics?.group,
        clientTs: new Date().getTime(),
        subFlow: diagnostics?.subFlow || '',
        metaData: diagnostics?.metaData
      });
    }
  };

  return { sendAmeyoDiagnostics };
};

export default useAmeyoDiagnostics;
